import * as React from 'react';

import {getDefaultActivityType} from '../../core/activities/get-default-activity-type';

import {defaultDurationOption} from './consts';
import {TimelineCreatorForm} from './timeline-creator-form';
import type {OwnProps} from './timeline-creator-form';

export function PeepTimelineCreatorForm(props: OwnProps) {
    const [htmlValue, setHtmlValue] = React.useState<string>('');
    const [plaintextValue, setPlaintextValue] = React.useState<string>('');
    const [activityTypeId, setActivityTypeId] = React.useState<string | null | undefined>(
        getDefaultActivityType()
    );
    const [durationMinutes, setDurationMinutes] = React.useState<number>(
        defaultDurationOption.value
    );
    const [pinNote, setPinNote] = React.useState<boolean>(false);
    const [isTranscribing, setIsTranscribing] = React.useState<boolean>(false);

    const handleResetAfterSubmit = () => {
        setActivityTypeId(getDefaultActivityType());
        setDurationMinutes(defaultDurationOption.value);
        setPinNote(false);
    };

    return (
        <TimelineCreatorForm
            {...props}
            htmlValue={htmlValue}
            plaintextValue={plaintextValue}
            onChange={(hv, pv) => {
                setHtmlValue(hv);
                setPlaintextValue(pv);
            }}
            activityTypeId={activityTypeId}
            setActivityTypeId={setActivityTypeId}
            durationMinutes={durationMinutes}
            setDurationMinutes={setDurationMinutes}
            pinNote={pinNote}
            setPinNote={setPinNote}
            isTranscribing={isTranscribing}
            setIsTranscribing={setIsTranscribing}
            onResetAfterSubmit={handleResetAfterSubmit}
        />
    );
}
